var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarsFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.1875 0.75H9.8125V1.78125H0.1875V0.75ZM1.5625 4.1875H8.4375V5.21875H1.5625V4.1875ZM6.375 7.625V8.65625H3.625V7.625H6.375Z",
    fill: "#3A8FD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarsFilter);
export default __webpack_public_path__ + "static/media/bars-filter.45f11871f60998ffc4d7499b3840c682.svg";
export { ForwardRef as ReactComponent };